import React from 'react'
import PropTypes from 'prop-types'
import * as Styled from './Spinner.styles'

const Spinner = ({ 'data-test': dataTest, kind, size, centered, ...props }) => {
  const strokeWidth = size <= 50 ? 5 : 3
  return (
    <Styled.Spinner aria-busy='true' data-test={dataTest} size={size} centered={centered} {...props}>
      <Styled.SVG viewBox='0 0 100 100' size={size}>
        <Styled.Circle kind={kind} cx='50' cy='50' r='20' fill='none' strokeWidth={strokeWidth} strokeMiterlimit='10' />
      </Styled.SVG>
    </Styled.Spinner>
  )
}

Spinner.propTypes = {
  /**
   * Specify the kind of spinner - default (red) or white
   */
  kind: PropTypes.oneOf(['default', 'white', 'green']),

  /**
   * Specify the whether the spinner is centered within its container (absolutely positioned - take care!)
   */
  centered: PropTypes.bool,

  /**
   * Specify the size of the spinner (width and height have the same value)
   */
  size: PropTypes.number,

  /**
   * Specify an optional data-test attribute to be added to your Spinner for e2e testing
   */
  'data-test': PropTypes.string
}

Spinner.defaultProps = {
  className: '',
  size: 100,
  kind: 'default',
  centered: false
}

export default Spinner
